// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AKiG","col":"styles_col__1IXR9"};